<template>
  <main>
    <div class="l-main-content__inner">

      <div class="c-page-header">
        <h1 class="c-page-header-title">生徒別 学習状況</h1>
        <div class="c-page-header__return">
          <a
            v-if="conditions"
            :href="learningStatusClassUrl"
            class="c-button-white -return -teacher"
          >
            <span class="label">戻る</span>
          </a>
        </div>
      </div>

        <dl class="p-learning-filtering -no-gap">
          <div class="item">
            <dt class="item__title">学年</dt>
            <dd class="item__data">
              <p class="val">
                <span class="val__num">{{ displayAcademicYear }}</span>年
              </p>
            </dd>
          </div>
          <div v-if="displayClassroomName" class="item">
            <dt class="item__title">学級</dt>
            <dd class="item__data">
              <p class="val">{{ displayClassroomName }}</p>
            </dd>
          </div>
        </dl>
        <dl class="p-learning-filtering -no-gap">
          <!-- 生徒 -->
          <select-single
            v-if="studentList"
            title="名前"
            :options="studentList"
            v-model:selected="studentProfileId"
            @change="changeStudent"
          ></select-single>
        </dl>

      <section>

        <subject-tabs :subject="subject" @click="clickSubject"></subject-tabs>

        <div class="c-parts-box -white -learning">
          <div id="all_slide" class="p-learning-detail">
            <!-- 教材 -->
            <learning-status-work-selector
              :academicSessionId="academicSessionId"
              :academicYear="academicYear"
              :subject="subject"
              v-model:workId="workId"
              @change="changeWork"
            ></learning-status-work-selector>

            <div class="p-learning-detail-cont__wrapper">
              <div class="p-learning-detail-cont">
                <div class="p-learning-detail-cont__head">
                  <div class="p-learning-detail-cont__title">
                    <span class="iconClock"></span>{{ studentName }}の学習時間
                  </div>
                  <ul class="p-learning-detail-cont__data">
                    <li>累計<span class="num">{{Math.floor(totalStudyMinutes.total_study_minutes/60)}}</span><span class="unit">時間</span>
                    <span class="num">{{totalStudyMinutes.total_study_minutes%60}}</span><span class="unit">分</span></li>
                    <li class="js-averageGuide">学級平均<span class="graph__line"></span></li>
                  </ul>
                </div>

                <div class="learningDetailCont__main">
                <!-- 年間の場合に表示するテンプレート -->
                  <template v-if="period===3">
                    <div class="speechBubble">
                      <div class="speechBubble__inner">
                        <div class="label">今年は<span class="num">{{getHours(detailByYear)}}</span>時間<span class="num">{{getMinutes(detailByYear)}}</span>分勉強しました(前の期間より<span class="symbol--minus" v-if="isMinus(detailByYear)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinus(detailByYear)}">{{getDiffHours(detailByYear)}}</span>時間<span :class="{num: true, 'num--minus': isMinus(detailByYear)}">{{getDiffMinutes(detailByYear)}}</span>分)</div>
                        <div class="speechBubble__arrow"></div>
                      </div>
                    </div>
                   </template>

                <!-- 月間の場合に表示するテンプレート -->
                  <template v-if="period===2">
                    <div class="speechBubble">
                      <div class="speechBubble__inner">
                        <div class="label">今月は<span class="num">{{getHours(detailByMonth)}}</span>時間<span class="num">{{getMinutes(detailByMonth)}}</span>分勉強しました(前の期間より<span class="symbol--minus" v-if="isMinus(detailByMonth)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinus(detailByMonth)}">{{getDiffHours(detailByMonth)}}</span>時間<span :class="{num: true, 'num--minus': isMinus(detailByMonth)}">{{getDiffMinutes(detailByMonth)}}</span>分)</div>
                        <div class="speechBubble__arrow"></div>
                      </div>
                    </div>
                   </template>

                <!-- 週間の場合に表示するテンプレート -->
                  <template v-if="period===1">
                    <div class="speechBubble">
                      <div class="speechBubble__inner">
                        <div class="label">今週は<span class="num">{{getHours(detailByWeek)}}</span>時間<span class="num">{{getMinutes(detailByWeek)}}</span>分勉強しました(前の期間より<span class="symbol--minus" v-if="isMinus(detailByWeek)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinus(detailByWeek)}">{{getDiffHours(detailByWeek)}}</span>時間<span :class="{num: true, 'num--minus': isMinus(detailByWeek)}">{{getDiffMinutes(detailByWeek)}}</span>分)</div>
                        <div class="speechBubble__arrow"></div>
                      </div>
                    </div>
                   </template>

                  <div class="p-learning-detail-figure p-learning-detail-figure--block">
                  <p class="ChartUnit">（時間）</p>
                    <student-line-chart
                      :chart-data="studyMinutes"
                      name="timeLineChart"
                      ></student-line-chart>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-learning-detail-cont__wrapper">
              <div class="p-learning-detail-cont">
                <div class="p-learning-detail-cont__head">
                  <div class="p-learning-detail-cont__title">
                    <span class="iconAnswer"></span>{{ studentName }}の正答率
                  </div>
                  <ul class="p-learning-detail-cont__data">
                    <li>
                      <span class="num">{{correctAnswerRate.latest_correct_answer_rate}}</span><span class="unit">%</span><span class="all">(<span class="num">{{ correctAnswerRate.number_of_correct_answered }}</span>問/全<span class="num">{{ correctAnswerRate.number_of_answered }}</span>問）</span>
                    </li>
                    <li>初回<span class="graph__bar graph__bar--color3"></span></li>
                    <li>最新<span class="graph__bar"></span></li>
                  </ul>
                </div>
                <div class="learningDetailCont__main">
                  <div class="p-learning-detail-figure">
                    <div class="figureBarHorizontal">
                      <div class="chart">
                        <ul class="chart__scale">
                          <li class="item"><span class="item__num">0</span></li>
                          <li class="item"><span class="item__num">10</span></li>
                          <li class="item"><span class="item__num">20</span></li>
                          <li class="item"><span class="item__num">30</span></li>
                          <li class="item"><span class="item__num">40</span></li>
                          <li class="item"><span class="item__num">50</span></li>
                          <li class="item"><span class="item__num">60</span></li>
                          <li class="item"><span class="item__num">70</span></li>
                          <li class="item"><span class="item__num">80</span></li>
                          <li class="item"><span class="item__num">90</span></li>
                          <li class="item">
                            <span class="item__num">
                              <span class="unit unit--percent">100</span>
                            </span>
                          </li>
                        </ul>
                        <ul class="chart__bar">
                          <li class="item item--addBar item--latest2">
                            <div
                              class="item__fill"
                              :style="{width: correctAnswerRate.first_time_correct_answer_rate + '%'}"
                            >
                              <span
                                :class="{num: true, 'num--outsize': correctAnswerRate.first_time_correct_answer_rate < 90}"
                              >{{correctAnswerRate.first_time_correct_answer_rate}}</span>
                            </div>
                          </li>
                          <li class="item item--addBar item--average">
                            <div
                              class="item__fill"
                              :style="{width: correctAnswerRate.latest_correct_answer_rate + '%'}"
                            >
                              <span
                                :class="{num: true, 'num--outsize': correctAnswerRate.latest_correct_answer_rate < 90}"
                              >{{correctAnswerRate.latest_correct_answer_rate}}</span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </section>

    </div>
  </main>
</template>

<script setup lang="ts">
  import {ref, computed, onMounted} from "vue";
  import { PERIODS } from "@/consts/display_period";
  import { CORRECT_ANSWER_RATE_TYPE } from "@/consts/correct_answer_rate";
  import { SUBJECTS, SUBJECT_ALL } from "@/consts/subject";
  import { useLearningStatusYearStore } from "@/store/teacher/learning_status_year_store";
  import { useLearningStatusStudentStore } from "@/store/teacher/learning_status_student_store";

  const learningStatusYearStore = useLearningStatusYearStore()
  const learningStatusStudentStore = useLearningStatusStudentStore()

  // 教材セレクトボックスの教材取得、表示用学年・学級名引き当てのみに使用する。生徒一覧・学習状況データ取得には使用しない (NFR-7276)
  const academicSessionId = ref<number | null>(null);
  const academicYear = ref<number>(null);
  const classroom = ref("");
  const subject = ref(SUBJECT_ALL.value);
  const period = ref(PERIODS[0].value);
  const workId = ref<number | string>('');
  const correctAnswerRateType = ref(CORRECT_ANSWER_RATE_TYPE[0].value);
  const studentProfileId = ref<number>(null);
  const correctAnswerRate = ref({
    number_of_answered: 0,
    number_of_correct_answered: 0,
    first_time_correct_answer_rate: 0,
    latest_correct_answer_rate: 0
  });
  const detailByYear = ref({
    study_minutes: 0,
    study_minutes_previous: 0,
    monthly_data: []
  });
  const detailByMonth = ref({
    study_minutes: 0,
    study_minutes_previous: 0,
    weekly_data: []
  });
  const detailByWeek = ref({
    study_minutes: 0,
    study_minutes_previous: 0,
    daily_data: []
  });
  const classroomAverageByYear = ref({monthly_data: []});
  const classroomAverageByMonth = ref({weekly_data: []});
  const classroomAverageByWeek = ref({daily_data: []});
  const studyMinutes = ref({
    datasets: [],
    labels: [],
  });
  const totalStudyMinutes = ref({total_study_minutes: 0});

  const conditions = computed(() => {
    return learningStatusYearStore.yearConditions;
  })

  const learningStatusClassBaseUrl = computed(() => {
    return learningStatusYearStore.yearConditions.learningStatusClassBaseUrl;
  })

  const learningStatusClassUrl = computed(() => {
    // 戻るボタン用URL取得
    if (learningStatusClassBaseUrl.value) {
      return (
        learningStatusClassBaseUrl.value +
        "?" +
        getQueryString(getLearningStatusClassQueryParams())
      );
    }
  })

  const displayAcademicYear = computed(() => {
    if (!conditions.value) {
      // API 呼び出し未完了
      return null
    }

    const academicYears = conditions.value.academicYears[academicSessionId.value]
    const matchedAcademicYear = academicYears.find(yearOption => yearOption.value === academicYear.value)
    if (!matchedAcademicYear) {
      // リクエストパラメーターの学年に合致する学年なし
      return null
    }

    return matchedAcademicYear.value
  })

  const displayClassroomName = computed(() => {
    if (!conditions.value) {
      // API 呼び出し未完了
      return null
    }
    const classrooms = conditions.value.classrooms[academicSessionId.value][academicYear.value]
    if (!classrooms || classrooms.length === 0) {
      // リクエストパラメーターの学年に合致する学級なし
      return null
    }

    const matchedClassroom = classrooms.find(classroomOption => classroomOption.value === classroom.value)
    if (!matchedClassroom) {
      // リクエストパラメーターの学級UUIDに合致する学級なし
        return null
    }

    return matchedClassroom.name
  })

  const studentList = computed(() => {
    // FIXME NFR-3933: learningStatusStudentStore.students の単純なパススルーで加工が一切ないため、
    // このcomputedは廃止し、テンプレート・studentNameから learningStatusStudentStore.students を直接参照するで良さそう
    return learningStatusStudentStore.students;
   })

  const studentName = computed(() => {
    if (studentList.value) {
      const student =  studentList.value.find(student => student.value === studentProfileId.value)

      if (student) {
        return student.name
      }
    }
    return "生徒"
  })

  function getQueryString(queryParams) {
    // 渡されたクエリパラメータ用データをクエリ文字列化する
    return Object.entries(queryParams)
      .map(queryParam => `${queryParam[0]}=${queryParam[1]}`)
      .join("&");
  }

  function getLearningStatusClassQueryParams() {
    // T8-2のクエリパラメータを返す
    return {
      classroom: classroom.value,
      academic_session_id: academicSessionId.value,
      academic_year: academicYear.value,
      subject: subject.value,
      period: period.value,
      correct_answer_rate_type: correctAnswerRateType.value,
      ...(workId.value !== '' && { work: workId.value }),
    };
  }

  onMounted(() => {
    // Data properties にクエリパラメーターをセット
    setInitialDataFromSearchParams();
    // クエリパラメーターに応じた初期表示データを取得
    searchInitialDataFromSearchParams();
  })

  function searchInitialDataFromSearchParams() {
    // 検索条件 (学年・学級一覧) を取得
    learningStatusYearStore.fetchLearningStatusYearConditions()

    if (academicYear.value && classroom.value) {
      learningStatusStudentStore.fetchLearningStatusStudentListStudents({classroom_uuid: classroom.value});

      if (studentProfileId.value && subject.value) {
        fetchChartData()
      }
    }
    // ユーザーが指定したクエリパラメータが無効の場合は、
    // デフォルト値でAPI呼び出しするので、history も同期しておく
    replaceHistory()
  }

  function getLearningStatusQueryParams() {
    let params = {}

    // クエリパラメータに学年だけ指定がある場合
    if (academicYear.value) { params["academic_year"] = academicYear.value }
    // クエリパラメータに学級まで指定がある場合
    if (academicYear.value && classroom.value) { params["classroom"] = classroom.value }
    // クエリパラメータに教科まで指定がある場合
    if (academicYear.value && classroom.value && subject.value) { params["subject"] = subject.value }
    // クエリパラメータに表示期間まで指定がある場合
    if (academicYear.value && classroom.value && subject.value && period.value) {
      params["period"] = period.value
    }
    // クエリパラメータに正答率タイプまで指定がある場合
    if (academicYear.value && classroom.value && subject.value && period.value
      && correctAnswerRateType.value) {
      params["correct_answer_rate_type"] = correctAnswerRateType.value
    }
    // クエリパラメータに生徒まで指定がある場合
    if (academicYear.value && classroom.value && subject.value && period.value
      && correctAnswerRateType.value && studentProfileId.value) {
      params["student_id"] = studentProfileId.value
    }

    // academicSessionId は、生徒一覧・学習状況データ取得には使用しないため、単にsetInitialDataFromSearchParams と同期だけする
    // クエリパラメータに年度idがある場合
    if (academicSessionId.value) { params["academic_session_id"] = academicSessionId.value }
    // クエリパラメータに教材がある場合
    // APIリクエストパラメーターと同期する
    if (workId.value !== '') { params["work"] = workId.value }

    return params
  }

  function replaceHistory() {
    history.replaceState(
      getLearningStatusQueryParams(),
      "",
      `?${getQueryString(getLearningStatusQueryParams())}`
    )
  }

  function setInitialDataFromSearchParams() {
    // クエリパラメーターから初期値を設定
    // cf. https://developer.mozilla.org/ja/docs/Web/API/URL/searchParams
    let params = new URL(location.toString()).searchParams;

    if (params.has("classroom")) {
      const found = params.get("classroom");
      classroom.value = found ? params.get("classroom") : null;
    }
    if (params.has("academic_session_id")) {
      const parsed = parseInt(params.get("academic_session_id"), 10);
      academicSessionId.value = !isNaN(parsed) ? parsed : null;
    }
    if (params.has("academic_year")) {
      const parsed = parseInt(params.get("academic_year"), 10);
      academicYear.value = !isNaN(parsed) ? parsed : null;
    }
    if (params.has("subject")) {
      const found = SUBJECTS.find(
        subject => subject.value === params.get("subject")
      );
      subject.value = found ? params.get("subject") : SUBJECT_ALL.value;
    }
    if (params.has("period")) {
      const parsed = parseInt(params.get("period"), 10);
      const found = PERIODS.find(period => period.value === parsed);
      period.value = !isNaN(parsed) && found ? parsed : PERIODS[0].value;
    }
    if (params.has("correct_answer_rate_type")) {
      const parsed = parseInt(params.get("correct_answer_rate_type"), 10);
      correctAnswerRateType.value = !isNaN(parsed) ? parsed : null;
    }
    if (params.has("student_id")) {
      const parsed = parseInt(params.get("student_id"), 10);
      studentProfileId.value = !isNaN(parsed) ? parsed : null;
    }
    if (params.has("work")) {
      const parsed = parseInt(params.get("work"), 10);
      workId.value = !isNaN(parsed) ? parsed : '';
    }
  }

  // 生徒セレクトボックス操作時の処理
  function changeStudent() {
    searchLearningStatus()
  }

  // 教材セレクトボックス操作時の処理
  function changeWork() {
    searchLearningStatus()
  }

  // 教科タブ操作時の処理
  function clickSubject(name) {
    subject.value = name
    workId.value = ''
    searchLearningStatus()
  }

  async function fetchChartData() {
    // 生徒の正答率取得
    correctAnswerRate.value = await learningStatusStudentStore.fetchLearningStatusStudentCorrectAnswerRate(
      {
        student_id: studentProfileId.value,
        subject: subject.value,
        work: workId.value !== '' ? workId.value : undefined,
      }
    )
    // 生徒の学習時間取得
    let date = new Date()
    let current_year = date.getFullYear()
    let current_month = date.getMonth() + 1

    if (period.value == 1) {
      // 週間の詳細と学級平均
      let params = {
        student_id: studentProfileId.value,
        subject: subject.value,
        work: workId.value !== '' ? workId.value : undefined,
      };
      detailByWeek.value = await learningStatusStudentStore.fetchLearningStatusStudentFetchDetailByWeek(params);
      classroomAverageByWeek.value = await learningStatusStudentStore.fetchLearningStatusStudentFetchAvgByWeek(params);
    } else if (period.value == 2) {
      // 月間の詳細と学級平均
      let params = {
        student_id: studentProfileId.value,
        subject: subject.value,
        year: current_year,
        month: current_month,
        work: workId.value !== '' ? workId.value : undefined,
      };
      detailByMonth.value = await learningStatusStudentStore.fetchLearningStatusStudentFetchDetailByMonth(params);
      classroomAverageByMonth.value = await learningStatusStudentStore.fetchLearningStatusStudentFetchAvgByMonth(params);
    } else {
      // 年間の詳細と学級平均
      let params = {
        student_id: studentProfileId.value,
        subject: subject.value,
        year: current_year,
        work: workId.value !== '' ? workId.value : undefined,
      };
      detailByYear.value = await learningStatusStudentStore.fetchLearningStatusStudentFetchDetailByYear(params);
      classroomAverageByYear.value = await learningStatusStudentStore.fetchLearningStatusStudentFetchAvgByYear(params);
    }
    studyMinutes.value = getStudyMinutes()

    // 学習時間の累計取得
    totalStudyMinutes.value = await learningStatusStudentStore.fetchLearningStatusStudentFetchTotalStudyMinutes(
      {
        student_id: studentProfileId.value,
        subject: subject.value,
        work: workId.value !== '' ? workId.value : undefined,
      }
    );
  }

  function searchLearningStatus() {
    // チャートデータ取得
    if (studentProfileId.value && subject.value) {
      fetchChartData()
      replaceHistory()
    }
  }

  function getHours(item){
    return Math.floor(item.study_minutes/60);
  }

  function getMinutes(item){
    return item.study_minutes%60;
  }

  function isMinus(item){
    return (item.study_minutes - item.study_minutes_previous) < 0;
  }

  function getDiffMinutes(item){
    return Math.abs(item.study_minutes - item.study_minutes_previous)%60;
  }

  function getDiffHours(item){
    return Math.floor(Math.abs(item.study_minutes - item.study_minutes_previous)/60);
  }

  function getStudyMinutes() {
    let datasets: Array<any> = [];
    let labels: Array<any> = ['',];
    let data: Array<any> = [null,];
    let avgData: Array<any> = [null,];

    if (period.value == 1) {
      // 週間表示
      detailByWeek.value.daily_data.forEach(item => {
        let weekday = new Date(item.year, item.month-1, item.day).toLocaleDateString("ja-JP", {weekday: "short"})
        labels.push(`${item.month}/${item.day}(${weekday})`)
        if (item.study_minutes == null) {
          data.push(`${item.study_minutes}`)
        } else {
          data.push(`${item.study_minutes/60}`)
        }
      })
      classroomAverageByWeek.value.daily_data.forEach(item => {
        if (item.study_minutes == null) {
          avgData.push(`${item.study_minutes}`)
        } else {
          avgData.push(`${item.study_minutes/60}`)
        }
      })
    } else if (period.value == 2) {
      // 月間表示
      detailByMonth.value.weekly_data.forEach((item, index) => {
        labels.push(`${item.begin.month}月${index+1}週`)
        if (item.study_minutes == null) {
          data.push(`${item.study_minutes}`)
        } else {
          data.push(`${item.study_minutes/60}`)
        }
      })
      classroomAverageByMonth.value.weekly_data.forEach(item => {
        if (item.study_minutes == null) {
          avgData.push(`${item.study_minutes}`)
        } else {
          avgData.push(`${item.study_minutes/60}`)
        }
      })
    } else {
      // 年間表示
      detailByYear.value.monthly_data.forEach(item => {
        labels.push(`${item.month}月`)
        if (item.study_minutes == null) {
          data.push(`${item.study_minutes}`)
        } else {
          data.push(`${item.study_minutes/60}`)
        }
      })
      classroomAverageByYear.value.monthly_data.forEach(item => {
        if (item.study_minutes == null) {
          avgData.push(`${item.study_minutes}`)
        } else {
          avgData.push(`${item.study_minutes/60}`)
        }
      })
    }
    labels.push('')
    data.push(null)
    avgData.push(null)
    datasets.push({
      label: '学習時間',
      backgroundColor: "rgba(0,0,0,0)",
      borderColor: "rgba(41, 101, 247, 1)",
      data: data,
      tension: 0,
      borderWidth: 4,
      pointBackgroundColor: "rgba(41, 101, 247, 1)",
      pointBorderColor: "rgba(255, 255, 255, 1)",
      pointHoverBorderColor: "rgba(255, 255, 255, 1)",
      pointBorderWidth: 4,
      pointRadius: 8,
      pointHoverRadius: 8,
      pointHitRadius: 4,
    })
    datasets.push({
      label: '学級平均',
      data: avgData,
      borderColor: "rgba(204, 204, 204, 1)",
      backgroundColor: "rgba(0,0,0,0)",
      tension: 0,
      borderWidth: 3,
      pointBackgroundColor: "rgba(204, 204, 204, 1)",
      pointBorderColor: "rgba(255, 255, 255, 1)",
      pointHoverBorderColor: "rgba(255, 255, 255, 1)",
      pointBorderWidth: 4,
      pointRadius: 8,
      pointHoverRadius: 8,
      pointHitRadius: 4,
    })
    return {labels: labels, datasets: datasets}
  }
</script>
